import React, { useCallback } from 'react'
import { useNewTranslation } from 'hooks'
import BlockMenu, { BLOCK_GROUP, BlockType } from './BlockMenu'
import PopoverButton from 'components/Shared/Button/PopoverButton'

type AddBlockButtonProps = {
    onSelected?: (blockType: BlockType) => void
    blockGroup: BLOCK_GROUP
    showNonSubmissionBlockOnly?: boolean
}
const AddBlockButton: React.FC<AddBlockButtonProps> = ({
    onSelected,
    blockGroup,
    showNonSubmissionBlockOnly = false,
}) => {
    const [t] = useNewTranslation()

    const handleSelectedMenu = useCallback(
        (blockType: BlockType): void => {
            if (onSelected) {
                onSelected(blockType)
            }
        },
        [onSelected],
    )

    return (
        <PopoverButton
            popoverTitleText={t('button.addStep')}
            buttonProps={{
                label: t('button.campaignEditor.addField'),
                icon: 'plus',
                className: 'width-fit-content',
            }}
            isVerticalMenu={false}
        >
            {(closePopup: () => void) => (
                <BlockMenu
                    onSelect={(blockType: BlockType) => {
                        closePopup()
                        handleSelectedMenu(blockType)
                    }}
                    blockGroup={blockGroup}
                    showNonSubmissionBlockOnly={showNonSubmissionBlockOnly}
                />
            )}
        </PopoverButton>
    )
}

export default AddBlockButton
